module.exports = __webpack_public_path__ + "img/bg-1123.93d8b738.png";